"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoFilledIcon = void 0;
/* eslint-disable max-len */
var react_1 = __importStar(require("react"));
var Icon_1 = require("./Icon");
exports.InfoFilledIcon = (0, react_1.forwardRef)(function InfoFilledIcon(props, ref) {
    return (react_1.default.createElement(Icon_1.Icon, __assign({ ref: ref, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", 
            // eslint-disable-next-line max-len
            d: "M12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22ZM11.7998 7.64227C11.7998 8.14727 12.1978 8.57527 12.9018 8.57527C13.5898 8.57527 14.0948 8.19327 14.2478 7.58127C14.2778 7.45827 14.2938 7.32127 14.2938 7.21327C14.2938 6.70827 13.8958 6.28027 13.1918 6.28027C12.5188 6.28027 11.9988 6.66227 11.8458 7.27427C11.8158 7.39727 11.7998 7.53427 11.7998 7.64227ZM11.4618 17.5043C10.4368 17.5043 10.0998 16.8763 10.0998 16.2943C10.0998 16.0503 10.1768 15.6833 10.2378 15.4693L11.3078 10.8573H10.0548C10.0171 10.8572 9.97998 10.8486 9.94611 10.8322C9.91224 10.8158 9.88251 10.7919 9.85915 10.7624C9.83579 10.7329 9.81939 10.6985 9.81119 10.6618C9.80298 10.625 9.80318 10.5869 9.81176 10.5503L9.88776 10.2253C9.90336 10.1585 9.93821 10.0979 9.98799 10.0507C10.0378 10.0036 10.1003 9.97218 10.1678 9.96027L13.0058 9.46027C13.0873 9.44594 13.1712 9.4521 13.2498 9.4782C13.3285 9.5043 13.3994 9.54952 13.4562 9.6098C13.513 9.67009 13.5539 9.74354 13.5753 9.82357C13.5967 9.90359 13.5979 9.98768 13.5788 10.0683L12.1398 16.0503C12.1297 16.0919 12.1341 16.1357 12.1522 16.1745C12.1703 16.2133 12.201 16.2448 12.2394 16.2638C12.2777 16.2829 12.3214 16.2884 12.3632 16.2794C12.4051 16.2703 12.4426 16.2474 12.4698 16.2143L13.6348 14.7893C13.6879 14.7268 13.7629 14.687 13.8444 14.678C13.9259 14.6689 14.0078 14.6913 14.0733 14.7405C14.1389 14.7897 14.1832 14.8621 14.1972 14.9429C14.2112 15.0237 14.1939 15.1068 14.1488 15.1753L13.4488 16.1883C12.7148 17.2583 12.0428 17.5043 11.4618 17.5043Z", fill: "currentColor" })));
});
